export const PopupModals = {
	sessionExpiredForConcurrentConnections: 'session-expired-for-concurrent-connections',
} as const

export type PopupModalType = (typeof PopupModals)[keyof typeof PopupModals]
